import config from '../config';

const appConfig = config();

const apiInsurance = appConfig.apiPrefix;
const { v1 } = appConfig.apiVersion;

export default class InsuranceService {
  constructor(client) {
    this.client = client;
  }

  apiInsurance() {
    return this.client.get(`${apiInsurance}${v1}`);
  }

  massiveRegistrationInitialLoad(payload) {
    return this.client.post(
      `${apiInsurance}${v1}/massiveRegistration/initial-load`,
      payload
    );
  }

  getInsurances({ companyId, subHoldingId, holdingId, groupCompanyId }) {
    return this.client.get(`${apiInsurance}${v1}/insuranceCompany`, {
      params: { companyId, subHoldingId, holdingId, groupCompanyId }
    });
  }

  getAnInsurance(id) {
    return this.client.get(`${apiInsurance}${v1}/insuranceCompany/${id}`);
  }

  getInsuranceBrokers() {
    return this.client.get(`${apiInsurance}${v1}/insuranceBroker`);
  }

  postInsuranceBroker(payload) {
    return this.client.post(`${apiInsurance}${v1}/insuranceBroker`, payload);
  }

  putInsuranceBroker(insuranceBrokerId, payload) {
    return this.client.patch(
      `${apiInsurance}${v1}/insuranceBroker/${insuranceBrokerId}`,
      payload
    );
  }

  deleteInsuranceBroker(insuranceBrokerId) {
    return this.client.delete(
      `${apiInsurance}${v1}/insuranceBroker/${insuranceBrokerId}`
    );
  }

  postInsurance(payload) {
    return this.client.post(`${apiInsurance}${v1}/insuranceCompany`, payload);
  }

  putInsurance(insuranceCompanyId, payload) {
    return this.client.patch(
      `${apiInsurance}${v1}/insuranceCompany/${insuranceCompanyId}`,
      payload
    );
  }

  deleteInsurance(payload) {
    return this.client.delete(
      `${apiInsurance}${v1}/insuranceCompany/${payload}`
    );
  }

  getInsuranceCompanyExecutive(payload) {
    return this.client.get(
      `${apiInsurance}${v1}/insuranceCompany/${payload}/executives`
    );
  }

  postInsuranceCompanyExecutive(idInsurance, payload) {
    return this.client.post(
      `${apiInsurance}${v1}/insuranceCompany/${idInsurance}/executives`,
      payload
    );
  }

  putInsuranceCompanyExecutive(idInsurance, idExecutive, payload) {
    return this.client.put(
      `${apiInsurance}${v1}/insuranceCompany/${idInsurance}/executives/${idExecutive}`,
      payload
    );
  }

  deleteInsuranceCompanyExecutive(payload) {
    return this.client.delete(
      `${apiInsurance}${v1}/insuranceCompany/${payload.insuranceId}/executives/${payload.employeeId}`
    );
  }

  insuranceCompaniesRuts() {
    return this.client.get(`${apiInsurance}${v1}/insuranceCompany/ruts`);
  }
}
